/** @file The IK constraint a bone drives (as its target) or ends (as its last chain bone), target first. */
import type { Id } from '@pose2d/format/types';
import type { ToolContext } from '../../panels/viewport/viewportTypes';
import { ikRef, type IkRef } from '../transform/ikRef';

/** R-E1-13: the constraint whose target is `bone`, else the one whose chain ends at it; null for neither. */
export function ikOfBone(ctx: Pick<ToolContext, 'doc' | 'maps'>, bone: Id): IkRef | null {
  const all = Object.values(ctx.doc.constraints);
  const c = all.find((k) => k.target === bone) ?? all.find((k) => k.bones.at(-1) === bone);
  return c === undefined ? null : ikRef(ctx.maps, c);
}
